<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
铁路公园站<br>
站点介绍<br>
铁路公园站位于深圳市南山区怡海大道与规划四路路口，横跨怡海大道，车站东侧有现状平南铁路，南侧东部临近世贸、香江、金立地块。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:25	00:17	5号线	3分钟	5分25秒<br>
黄贝岭	06:18	23:05	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:28	00:17	5号线	4分钟	6分钟<br>
黄贝岭	06:23	23:05	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:28	01:17	5号线	4分钟	6分钟<br>
黄贝岭	06:23	00:05	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
自贸大街东侧（南）、颐湾府、深国际前海颐都大厦<br><br>
B出入口:<br>
自贸大街东侧（北）、怡海大道南侧（东）<br><br>
C出入口:<br>
怡海大道南侧（西）、自贸大街西侧（北）、港城街北侧<br><br>
D出入口:<br>
自贸西街、港城街南侧、前海自贸大厦<br><br>
公交换乘信息<br>
C出入口:<br>
公交站名： 铁路公园地铁站<br>
B991<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


